import React from "react";
import PropTypes from "prop-types";
import "./inputContainer.css";

export default function InputContainer(props) {
  const { onSubmit, value, handleInputChange } = props;
  return (
    <div>
      <input
        className="descInput"
        placeholder="Type Here"
        value={value}
        onChange={handleInputChange}
      />
      <button onClick={onSubmit}> Submit </button>
    </div>
  );
}

InputContainer.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired
};
